import gql from 'graphql-tag'

import { Query } from '../../types-graphql'
import { courseUserFragment, courseEvaluationDetailFragment } from './fragments'

export type TDataCourseUsers = Pick<Query, 'courseUsers' | '__typename'>

export type TDataCourseUserEvaluations = Pick<
  Query,
  'courseUsers' | '__typename'
>
export const COURSE_USER_EVALUATIONS = gql`
  query ($courseId: ID!, $userId: Int!) {
    courseUsers(courseId: $courseId, q: { user_id_eq: $userId }, perPage: 1) {
      nodes {
        userId
        allEvaluations {
          ...CourseEvaluationDetailFragment
        }
      }
    }
  }
  ${courseEvaluationDetailFragment}
`

export const COURSE_USERS = gql`
  query (
    $courseId: ID!
    $perPage: Int
    $page: Int
    $q: UserCourseRansack
    $areaId: ID
  ) {
    courseUsers(
      courseId: $courseId
      perPage: $perPage
      page: $page
      q: $q
      areaId: $areaId
    ) {
      nodes {
        ...CourseUserFragment
      }
      pagesCount
      nodesCount
      hasNextPage
      hasPreviousPage
    }
  }
  ${courseUserFragment}
`
